;(function($, undefined) {

    function current() {

        var now;

        $.ajax({
            dataType: "json",
            url: rnn.site.currentTimeURL,
            data: {},
            async: false,
            success: function(data) {
                now = toDate(data.date, data.time, data.timezone);
            }
        });

        return now;
    }

    function zuluStringToLocalDate(date) {
        var split_date = date.split('T'),
            date = split_date[0],
            time = split_date[1].replace(/\..*/, '');

        return toDate(date, time, rnn.site.timeZoneOffset, true);
    }

    function toDate(date, time, timezone, inUTC) {

        var serverDate = _.map(date.split('-'), Number),
            serverTime = _.map(time.split(':'), Number),
            serverOffset = Number(timezone) * (60 * 60 * 1000),
            utc;

        inUTC = inUTC === 'undefined' ? false: inUTC;

        date = new Date(serverDate[0], (serverDate[1]-1), serverDate[2], serverTime[0], serverTime[1], serverTime[2]);
        if (!inUTC) {
            utc = date.getTime() + date.getTimezoneOffset() * (60 * 1000);
        } else {
            utc = date.getTime();
        }
        return new Date(utc + serverOffset);
    }

    // Initialise Timestamps
    function initTimestamps() {
        $.extend($.timeago.settings.strings, {
            seconds: '< a minute',
            minute: 'a minute',
            hour: 'an hour',
            hours: '%d hours',
            month: 'a month',
            year: 'a year'
        });
        $('abbr.pubDate').timeago();
    }

    rnn.modules.register("time", {
        init: initTimestamps,
        current: current,
        zuluStringToLocalDate: zuluStringToLocalDate
    });


})(jQuery);